import React from "react";
import { Link } from "react-router-dom";

export const CallforTutorial = () => {
  return (
    <div className="visa-big-box container">
      <h5>
        IHCI 2023 invites tutorial presenters to submit proposals for
        informative and educational tutorials to be held as part of the
        conference program. Tutorials provide an opportunity to delve deep into
        specific topics related to Human-Computer Interaction (HCI) and offer
        participants valuable insights, practical skills, and hands-on learning
        experiences. Here are the details and guidelines for submitting tutorial
        proposals
      </h5>
      <h4>1. Tutorial Topics</h4>
      <h5 className="information">
        We welcome tutorial proposals on a wide range of HCI-related topics,
        including but not limited to:
      </h5>
      <ul>
        <li>User experience design and evaluation methodologies</li>
        <li>Interaction design principles and best practices</li>
        <li>Prototyping and wireframing tools and methods</li>
        <li>Data visualization and visual analytics</li>
        <li>User-centered research methods</li>
        <li>Mobile and multi-device interfaces</li>
        <li>Ethical Considerations in HCI Research and Practice</li>
        <li>
          Designing for specific user populations (e.g., children, older adults)
        </li>
        <li>Novel interaction techniques and technologies</li>
      </ul>

      <h4>2. Tutorial Duration</h4>
      <h5 className="information">
        Tutorials can be either half-day or full-day sessions. Please specify
        the preferred duration of your tutorial in the proposal.
      </h5>

      <h4>3. Target Audience</h4>
      <h5 className="information">
        Specify the intended audience for your tutorial, such as researchers,
        practitioners, industry professionals, students, or a combination
        thereof. Clearly define the level of expertise or prior knowledge
        required for participants to benefit from the tutorial.
      </h5>

      <h4>4. Presenter Information</h4>
      <h5 className="information">
        Provide a brief introduction to the tutorial presenters, including their
        expertise and experience in the field of HCI. Include their affiliations
        and contact information.{" "}
      </h5>

      <h4>5. Tutorial Description</h4>
      <h5 className="information">
        Submit a detailed description of the tutorial, including the learning
        objectives, the topics to be covered, and the format of the tutorial
        (e.g., lectures, demonstrations, hands-on exercises). Explain how the
        tutorial addresses current challenges or emerging trends in HCI and how
        it benefits participants.{" "}
      </h5>

      <h4>6. Tutorial Outline</h4>
      <h5 className="information">
        Provide a proposed outline or agenda for the tutorial, including a
        breakdown of the topics to be covered and the estimated time allocated
        to each section.
      </h5>

      <h4>7. Materials and Resources</h4>
      <h5 className="information">
        Specify any special requirements, materials, or resources needed for the
        tutorial, such as software tools, datasets, or hardware. Clarify whether
        participants need to bring their laptops or any other equipment.
      </h5>

      <h4>8. Submission Guidelines</h4>
      <h5 className="information">
        To submit your tutorial proposal via the online{" "}
        <Link to="https://cmt3.research.microsoft.com/User/Login?ReturnUrl=%2FIHCI2023">
          CMT
        </Link>{" "}
        site or by email:{" "}
        <Link to="mailto:ihcisociety@gmail.com">ihcisociety@gmail.com</Link>,
        please provide a comprehensive document addressing the points mentioned
        above. Additionally, include a brief biography of the presenters,
        highlighting their qualifications and relevant experience.
      </h5>

      <h4>9. Deadline</h4>
      <h5 className="information">
        The deadline for tutorial proposals is{" "}
        <b style={{ textDecoration: "none", color: "#FF9933" }}>
          July 15, 2023
        </b>
        . Please ensure that your submission is completed before this date.
      </h5>
      <br />
      <br />
      <h5>
        We encourage tutorial proposals that offer valuable insights, practical
        skills, and hands-on learning experiences to participants. We look
        forward to receiving your proposals and hosting informative tutorials at
        IHCI 2023, where we aim to foster knowledge exchange and skill
        development in the field of Human-Computer Interaction.
      </h5>
      <hr className="hr-style" />
    </div>
  );
};
